export interface GetContractParamsOptions {
    fromAddress?: string;
    receiverAddress?: string;
    referrer?: string;
    useCacheData?: boolean;
}
